<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="bg-content padding15">
          <el-form size="small" label-width="100px" ref="searchRef">
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <!-- 按钮操作 -->
              <div class="padding15-tb text right">
                <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                <el-button size="small" @click="reset">重置</el-button>
              </div>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelByIds"
          >删除</el-button>
          <br/><br/>
          <el-table size="small" :data="conditionList.list" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column fixed property="routeConfName"  label="路由名称"  align="center"/>
            <el-table-column fixed label="路由类型" align="center" min-width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 2">场景模版</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="groupName"  label="所属策略"  align="center"/>
            <el-table-column fixed property="routeBusinessName"  label="目标模板"  align="center"/>
            <el-table-column fixed property="conKeyDesc" label="条件"  align="center"/>
            <el-table-column fixed property="conType" label="条件类型"  align="center"/>
            <el-table-column fixed property="operationLogicDesc" label="逻辑"  align="center"/>
            <el-table-column fixed property="conValues" label="条件值"  align="center"/>
            <el-table-column fixed property="createTime"  label="创建时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" icon="el-icon-delete" size="mini" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="conditionList.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!--    编辑    -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="条件" prop="keyId">
              <el-select v-model="form.keyId" placeholder="请选择" style="width: 80%;" @change="getConLogicOptionList" clearable filterable>
                <el-option
                  v-for="item in conKeyOption"
                  :key="item.id"
                  :label="item.description"
                  :value="item.id">
                  {{ item.description }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="逻辑" prop="operationLogic">
              <el-select v-model="form.operationLogic" placeholder="请选择" style="width: 80%;" @change="resetConValues">
                <el-option
                  v-for="item in conLogicOption"
                  :key="item.code"
                  :label="item.desc"
                  :value="item.code">
                  {{ item.desc }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="form.operationLogic" v-if="form.operationLogic && ['11', '12', '13', '14'].includes(form.operationLogic.toString())" label="参数" prop="confName1">
              <el-input  v-model="form.param1" placeholder="参数1" style="width: 38%;"/>&nbsp;-&nbsp;<el-input  v-model="form.param2" placeholder="参数2" style="width: 38%;"/>
            </el-form-item>
            <el-form-item v-show="form.operationLogic" v-else-if="form.operationLogic && ['19'].includes(form.operationLogic.toString())" label="参数" prop="confName1">
              <el-input  v-model="form.param1" placeholder="多个参数英文;分隔" style="width: 80%;"/>
            </el-form-item>
            <el-form-item  v-show="form.operationLogic" v-else label="参数" prop="confName2">
               <el-input  v-model="form.param1" placeholder="参数" style="width: 80%;"/>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确认</el-button>
            <el-button @click="cancel">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        startTime: null,
        endTime: null,
        type: 2,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      conditionList: { 'totalRecords': 0, list: [] },
      // 表单参数
      form: {
        param1: '',
        param2: '',
        conValues: null,
        operationLogic: null,
        conkey: null,
        keyId: null
      },
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 条件路由配置
      companyId: null,
      relationId: null,
      conKeyOption: [],
      conLogicOption: []
    };
  },
  mounted() {
    this.companyId = this.$route.params.companyId;
    this.relationId = this.$route.params.relationId;
    this.getList();
    this.getConKeyOptionList(this.companyId);
  },
  methods: {
    getList() {
      this.loading = true;
      this.searchReq.relationId = this.relationId;
      this.$ajax({
        method: 'get',
        url: '/commonDetail/list',
        params: this.searchReq
      }).then((res) => {
        this.conditionList.list = res.data.list;
        this.conditionList.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    updateButton(row) {
      this.form.keyId = row.keyId;
      this.form.conKey = row.conKey;
      this.getConLogicOptionList();
      this.form.operationLogic = row.operationLogic;
      this.form.conValues = row.conValues;
      if ([11, 12, 13, 14].includes(this.form.operationLogic)) {
        const params = this.form.conValues.split('_');
        this.form.param1 = params[0];
        this.form.param2 = params[1];
      } else {
        this.form.param1 = this.form.conValues;
        this.form.param2 = null;
      }
      this.resetForm();
      this.form.id = row.id;
    },
    handleAdd() {
      this.resetConKey();
      this.resetForm();
    },
    resetForm() {
      this.form.id = null;
      this.form.relationId = this.searchReq.relationId;
      this.open = true;
    },
    // 重置
    reset() {
      this.searchReq.relationId = this.relationId;
      this.searchReq.startTime = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    submitForm() {
      if ([11, 12, 13, 14].includes(this.form.operationLogic)) {
        if (this.form.param1 === null || this.form.param2 === null) {
          this.$message({
            type: 'error',
            message: '添加失败！区间必须有2个参数'
          });
          return;
        }
        this.form.conValues = `${this.form.param1}_${this.form.param2}`;
      } else {
        this.form.conValues = this.form.param1;
      }
      if (this.form.id) {
        this.$ajax({
          method: 'post',
          url: '/commonDetail/update',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      } else {
        this.$ajax({
          method: 'post',
          url: '/commonDetail/save',
          data: this.form
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
            this.open = false;
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        });
      }
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    handleDelByIds() {
      this.$confirm('是否确认删除 ?', '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: '/commonDetail/del',
          data: this.ids
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$confirm(`是否确认删除条件路由规则：${row.conKeyDesc} ?`, '警告', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'delete',
          url: `/commonDetail/del/${row.id}`
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '失败!'
            });
          }
        }).finally(() => {
          this.getList();
        });
      });
    },
    // 条件列表
    getConKeyOptionList(companyId) {
      this.$ajax({
        url: '/template/getFiledRouteOption',
        params: { 'companyId': companyId }
      }).then((res) => {
        this.conKeyOption = res.data;
      });
    },
    // 逻辑列表
    getConLogicOptionList() {
      if (this.form.keyId === undefined || this.form.keyId === null || this.form.keyId === '') {
        return;
      }
      this.resetConLogic();
      const keyId = this.form.keyId;
      this.$ajax({
        url: '/conditionDetail/getConLogicOptionList',
        method: 'POST',
        data: keyId
      }).then((res) => {
        this.conLogicOption = res.data;
      });
    },
    resetConKey() {
      this.resetConLogic();
      this.form.keyId = null;
    },
    resetConLogic() {
      this.resetConValues();
      this.form.operationLogic = null;
    },
    resetConValues() {
      this.form.param1 = null;
      this.form.param2 = null;
      this.form.conValues = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/condition/template/detail/index.vue